import React from 'react';

const {
  TextControl,
  SelectControl,
} = wp.components;

let __ = (arg) => {
  return arg;
};

if (wp.i18n) {
  __ = wp.i18n.__;
}
const {
  PlainText,
  MediaUpload
} = wp.editor;

export default class CustomInspectorControls extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    // console.log('this.props - ', this.props);
  }

  render() {

    // const ALLOWED_MEDIA_TYPES = ['audio'];
    let uploadSongLabel = __('Upload song');

    // const self = this;
    // console.log('CustomInspectorControls this.props - , ', this.props)
    return Object.keys(this.props.arr_options).map((optionIndex) => {

      const props = this.props;
      let option_array = this.props.arr_options[optionIndex];


      if(!option_array){
        // console.warn('error - ', key, this.props.arr_options[key])
        return '';
      }
      const configOptionKey = option_array.configOptionKey ? option_array.configOptionKey : optionIndex;

      // console.log('this - ', this);
      // console.log('option_array - ', option_array);

      // console.log('option_array - ', option_array);
      if (configOptionKey === 'layout' || configOptionKey === 'source' || configOptionKey === 'item_source') {
        return '';
      }

      if (configOptionKey === 'cat'){
        option_array.options = dzswtl_settings.cats;
      }
      // console.log('optionKey -' , configOptionKey);

      var argsInputForm = {
          label: option_array.title,
          value: props.attributes[configOptionKey] ? props.attributes[configOptionKey] : '',
          instanceId: configOptionKey,
          className:  ' dzs-dependency-field',
          onChange: (value) => {
            props.setAttributes({[configOptionKey]: value});
          }
          // onChange: (e,arg2) => {console.info(this, e,arg2); onValueChange(e,this)}
        }
      ;


      let Sidenote = null;
      if (option_array.description && !option_array.sidenote) {
        option_array.sidenote = option_array.description;
      }

      if (option_array.sidenote) {
        Sidenote = (
          <div className="sidenote" dangerouslySetInnerHTML={{__html: option_array.sidenote}}/>
        )
      }

      const divAtts = {
        className: "dzs-gutenberg--inspector-setting check-instanceid "
      };
      if (option_array.dependency) {
        divAtts['data-dependency'] = JSON.stringify(option_array.dependency);
      }

      if (option_array.type === 'text') {

        divAtts.className += 'type-'+option_array.type;
        return (
          <div {...divAtts}>
            <TextControl
              {...argsInputForm}
            />
            {Sidenote}
          </div>
        )
          ;
      }
      if (option_array.type === 'select') {

        if (option_array.choices && !(option_array.options)) {
          option_array.options = option_array.choices;
        }

        // delete args.instanceId ;

        // args.options = option_array.options;
        // console.info('select args - ',args);
        // console.info('option_array.options - ',option_array.options);

        divAtts.className += 'type-'+option_array.type;
        return (
          <div {...divAtts}>
            <SelectControl
              {...argsInputForm}
              options={option_array.options}
            />
            {Sidenote}
          </div>

        )
          ;
      }


      if (option_array.type === 'attach') {

        divAtts.className += 'type-'+option_array.type;
        if (option_array.upload_type) {

          // args.type = option_array.upload_type;
          argsInputForm.allowedTypes = [option_array.upload_type];
        }
        argsInputForm.onChange = null;


        if (props.attributes[configOptionKey]) {
          uploadSongLabel = __('Select another upload');
        }

        return (
          <div {...divAtts}>
            <label className="components-base-control__label">{option_array.title}</label>
            <MediaUpload
              {...argsInputForm}
              onSelect={(imageObject) => {
                props.setAttributes({[configOptionKey]: imageObject.url});
                console.log('imageObject - ', imageObject);
                console.info(' props - ', props);
              }}
              render={({open}) => (
                <div className="render-song-selector">
                  {props.attributes[configOptionKey] ? (
                    <PlainText
                      format="string"
                      formattingControls={[]}
                      placeholder={__('Input song name')}
                      onChange={(val) => props.setAttributes({[configOptionKey]: val})}
                      value={props.attributes[configOptionKey]}
                    />
                  ) : ""}
                  <button className="button-secondary" onClick={open}>{this.props.uploadButtonLabel}</button>
                </div>
              )}
            />
          </div>
        )
          ;
      }


    });

  }
}